/**
 * Backend access control — the operating-loop CRM is staff-only.
 *
 * For now: Workspace domain + an allowlist + demo mode are permitted. When custom
 * claims/roles are wired (setUserClaims function already exists), swap the domain
 * check for a role check (admin, exec, ops, sales_mgr, etc.).
 */
import { useAuth } from '../AuthContext';

const ALLOWLIST = ['randy@a10tion.digital'];

export interface Access { canBackend: boolean; reason: 'demo' | 'staff' | 'restricted'; }

export function useAccess(): Access {
  const { user, demo } = useAuth();
  if (demo) return { canBackend: true, reason: 'demo' };
  const email = (user?.email ?? '').toLowerCase();
  const ok = email.endsWith('@microflexfilm.com') || ALLOWLIST.includes(email);
  return { canBackend: ok, reason: ok ? 'staff' : 'restricted' };
}
